import React, { FC } from "react";

import Desktop from "./Desktop";
import Mobile from "./Mobile";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import TermsPage from "./Terms&Condition";
import PrivacyPolicy from "./PrivacyPolicy";
import CountUs from "./ContactUs";
import AffiliateLanding from "./AffiliateLanding";
import CalculatorPage from "./CalculatorPage";
import SocialCalculatorWidgetPage from "./SocialCalculatorWidgetPage";

const App: FC = () => {
  // Always show Desktop version for consistent design
  const showMobile = false;
  
  // Force rebuild: 2025-01-24 - This comment forces a new bundle hash

  // Debug: Log current pathname
  React.useEffect(() => {
    console.log('🔍 App.tsx - Current pathname:', window.location.pathname);
    console.log('🔍 App.tsx - Full URL:', window.location.href);
  }, []);

  return (
    <div style={{ backgroundColor: "#02162b", minHeight: "100vh", width: "100%", margin: 0, padding: 0 }}>
      <Router>
        <div style={{ backgroundColor: "#02162b", minHeight: "100vh", width: "100%" }}>
          <Switch>
            {/* CRITICAL: Affiliate landing must be FIRST route to ensure it matches before catch-all */}
            <Route 
              path="/affiliate/landing" 
              exact={true} 
              render={(props) => {
                console.log('✅✅✅ Route matched: /affiliate/landing');
                return <AffiliateLanding />;
              }} 
            />
            <Route path="/calculator-widget/:format" exact={true} component={SocialCalculatorWidgetPage} />
            <Route path="/calculator-widget" exact={true} component={SocialCalculatorWidgetPage} />
            <Route path="/calculator" exact={true} component={CalculatorPage} />
            <Route path="/terms&conditions" exact={true} component={TermsPage} />
            <Route path="/privacyPolicy" exact={true} component={PrivacyPolicy} />
            <Route path="/contactUs" exact={true} component={CountUs} />
            <Route 
              path="/" 
              exact={true}
              render={(props) => {
                // Early return if on affiliate landing path
                if (props.location.pathname === '/affiliate/landing') {
                  console.log('⚠️ WARNING: / route matched but pathname is /affiliate/landing - this should not happen!');
                  return <AffiliateLanding />;
                }
                console.log('🏠 Route matched: / (home)');
                return showMobile ? <Mobile /> : <Desktop />;
              }}
            />
            {/* Catch-all redirect to home */}
            <Route render={(props) => {
              // Early return if on affiliate landing path
              if (props.location.pathname === '/affiliate/landing') {
                console.log('⚠️ WARNING: Catch-all route matched but pathname is /affiliate/landing - this should not happen!');
                return <AffiliateLanding />;
              }
              console.log('🔄 Catch-all route matched, redirecting to home');
              return showMobile ? <Mobile /> : <Desktop />;
            }} />
          </Switch>
        </div>
      </Router>
    </div>
  );
};

export default App;

